import React from "react"

import FeatherIcon from "../../../../../design-system/feather-icon"
import { IconType } from "../../../../../design-system/feather-icon/feather-icon-map"
import Paragraph from "../../../../../design-system/paragraph"
import * as styles from "./index.module.scss"

interface Props {
  iconType: IconType
  label: string
  value: string | string[]
}

const MetadataInfo = ({ iconType, label, value }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FeatherIcon size="xlarge" type={iconType} />
      </div>
      <div className={styles.textColumn}>
        <div className={styles.label}>{label}</div>
        <Paragraph variant="3" className={styles.data}>
          {Array.isArray(value) ? value.join(", ") : value}
        </Paragraph>
      </div>
    </div>
  )
}

export default MetadataInfo
